import { PropsWithChildren } from 'react';

// The DTX SDK is loaded and initialized by AdsLayout (unconditionally, ahead of prebid),
// so this component is only a DOM marker for where DTX ad slots are rendered.
export const DTXAdsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <div id="dtx--ad--init">{children}</div>;
};
